gsap.registerPlugin(ScrollTrigger);

const colorThief = new ColorThief();
const cursorEl = cursor;

/* ==================== SAFE TEMP ELEMENT (NO LAYOUT SHIFT) ==================== */
const tempEl = document.createElement("div");

Object.assign(tempEl.style, {
  position: "fixed",
  top: "0",
  left: "0",
  opacity: "0",
  pointerEvents: "none",
  zIndex: "-1",
  padding: "20px",
  fontSize: "12px",
  maxWidth: "150px",
  wordBreak: "break-word",
  whiteSpace: "normal"
});

// Append safely (no scroll/height issue)
document.documentElement.appendChild(tempEl);

/* ==================== COLOR CACHE ==================== */
const colorCache = new WeakMap();

/* ==================== CORE FUNCTION ==================== */
function handleCursorEnter(target, img) {
  const card = target.closest("[data-cursor-text]");
  if (!card) return;

  const txt = card.getAttribute("data-cursor-text");
  if (!txt) return;

  /* ===== TEXT SIZE ===== */
  tempEl.textContent = txt;
  const size = Math.max(tempEl.offsetWidth, tempEl.offsetHeight) + "px";

  cursorEl.style.setProperty("--bubble-size", size);
  cursorEl.style.setProperty("--cursor-font-size", "12px");
  cursorEl.setAttribute("data-text", txt);
  cursorEl.classList.add("cursor--active-text");

  /* ===== COLOR EXTRACTION (CACHED) ===== */
  if (!img) return;

  try {
    if (!img.complete || img.naturalWidth === 0) return;

    let rgb = colorCache.get(img);

    if (!rgb) {
      rgb = colorThief.getColor(img);
      colorCache.set(img, rgb);
    }

    const [r, g, b] = rgb;

    const bg = `rgba(${r}, ${g}, ${b}, 0.35)`;
    cursorEl.style.setProperty("--cursor-bg", bg);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    cursorEl.style.setProperty("--cursor-text", brightness > 140 ? "#000" : "#fff");

  } catch (e) {
    console.warn("Color extraction failed", e);
  }
}

/* ==================== LEAVE ==================== */
function handleCursorLeave() {
  cursorEl.removeAttribute("data-text");
  cursorEl.classList.remove("cursor--active-text");
}

/* ==================== EVENT DELEGATION ==================== */
document.addEventListener("mouseover", (e) => {

  // CARD + COLLAGE
  if (e.target.matches(".card img, .collage-card img")) {
    handleCursorEnter(e.target, e.target);
  }

  // BENTO
  if (e.target.matches(".bento-overlay")) {
    const card = e.target.closest(".bento-item");
    const img = card?.querySelector(".bento-img img");
    handleCursorEnter(e.target, img);
  }

});

document.addEventListener("mouseout", (e) => {

  if (
    e.target.matches(".card img, .collage-card img, .bento-overlay")
  ) {
    handleCursorLeave();
  }

});

/* ==================== GSAP REVEAL ==================== */
gsap.utils.toArray(".card-animate").forEach((box, i) => {
  gsap.from(box, {
    y: 120,
    opacity: 0,
    duration: 1,
    delay: i * 0.12,
    ease: "power3.out",
    scrollTrigger: {
      trigger: box,
      start: "top 85%"
    }
  });
});